import { render, staticRenderFns } from "./Hospitalisation.vue?vue&type=template&id=4fb1b400"
import script from "./Hospitalisation.vue?vue&type=script&lang=js"
export * from "./Hospitalisation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports